module.exports = __webpack_public_path__ + "img/add-institute.2794e02b.svg";